import $ from 'jquery'

/**
 * @package     Image Hopper
 * @copyright   Copyright (c) 2021, Image Hopper
 * @license     http://opensource.org/licenses/gpl-2.0.php GNU Public License
 */

export function deleteFile (formId, fieldId, filename) {
  const $uploads = $('#gform_uploaded_files_' + formId)
  const filesJson = $uploads.val()

  if (filesJson) {
    const files = $.secureEvalJSON(filesJson)

    if (files) {
      const fileIndex = files['input_' + fieldId].findIndex((file) => {
        if (file.temp_filename === filename || file.uploaded_filename === filename) {
          return true
        }
      })

      if (fileIndex !== -1) {
        files['input_' + fieldId].splice(fileIndex, 1)
      }

      $uploads.val($.toJSON(files))
    }
  }
}
